import { LOGO_URL } from "@/lib/logos";

/**
 * Zeblan wordmark logo — single canonical asset used everywhere.
 * The `variant` prop is accepted for backwards-compat but ignored.
 */
export default function Logo({ className = "h-12 w-auto", alt = "Zeblan" }) {
  return (
    <img
      src={LOGO_URL}
      alt={alt}
      className={className}
      style={{ objectFit: "contain" }}
      data-testid="zeblan-logo"
      draggable={false}
    />
  );
}
